import { render } from "./MainContentComponent.vue?vue&type=template&id=b61e876e"
import script from "./MainContentComponent.vue?vue&type=script&lang=js"
export * from "./MainContentComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\anygence\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__